import { Link } from "react-router-dom";
import { Camera, Video, Receipt, MapPin, Users, ChevronRight, Coffee } from "lucide-react";
import { StatusBadge } from "../dash/ui";
import { ACTIVITY_TYPES, formatDay, formatRupiah, mediaSrc, productionText } from "../../lib/labels";

export const MediaThumb = ({ m, className = "h-full w-full object-cover" }) => {
  const src = mediaSrc(m);
  if (m.type === "VIDEO") return <video src={src} controls preload="metadata" playsInline className={className} />;
  if (m.type === "DOCUMENT")
    return (
      <a href={src} target="_blank" rel="noopener noreferrer" className="h-full w-full grid place-items-center bg-slate-100 text-xs font-semibold text-emerald-800 p-2 text-center">
        PDF · {m.originalFilename || "Dokumen"}
      </a>
    );
  return (
    <a href={src} target="_blank" rel="noopener noreferrer" className="block h-full w-full">
      <img src={src} alt={m.caption || "Bukti"} loading="lazy" className={className} />
    </a>
  );
};

export const StatusStamp = ({ value, testid }) => (
  <span className="uppercase tracking-wide"><StatusBadge value={value} testid={testid} /></span>
);

const Evidence = ({ c }) => (
  <span className="inline-flex flex-wrap gap-x-3 gap-y-1 text-xs text-slate-600">
    <span className="inline-flex items-center gap-1"><Camera className="h-3.5 w-3.5" />{c.photos} Foto</span>
    <span className="inline-flex items-center gap-1"><Video className="h-3.5 w-3.5" />{c.videos} Video</span>
    <span className="inline-flex items-center gap-1"><Receipt className="h-3.5 w-3.5" />{c.receipts} Nota</span>
  </span>
);

export const ActivityCard = ({ a, base }) => (
  <Link to={`${base}/kegiatan/${a.id}`} className="block bg-white border border-slate-200/80 rounded-xl p-4 sm:p-5 hover:border-emerald-600/40 transition-colors" data-testid={`activity-card-${a.id}`}>
    <div className="flex flex-wrap items-center justify-between gap-2">
      <span className="text-xs font-semibold text-slate-500">{formatDay(a.activityDate)} · {a.activityTime}</span>
      <StatusStamp value={a.status} testid={`activity-status-${a.id}`} />
    </div>
    <p className="mt-2 text-base font-extrabold tracking-wide text-slate-900 uppercase">{ACTIVITY_TYPES[a.activityType] || a.activityType}</p>
    <p className="text-sm text-slate-600 line-clamp-2 mt-1">{a.description}</p>
    <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-sm">
      <div><dt className="text-xs text-slate-500">Kebun</dt><dd className="font-mono text-xs font-semibold text-emerald-800">{a.projectCode}</dd></div>
      <div><dt className="text-xs text-slate-500">Area</dt><dd>{a.areaHectares != null ? `${a.areaHectares} Ha` : "-"}</dd></div>
      <div><dt className="text-xs text-slate-500">Total Biaya</dt><dd className="font-semibold" data-testid={`activity-cost-${a.id}`}>{a.totalCost ? formatRupiah(a.totalCost) : "Tanpa biaya"}</dd></div>
      <div><dt className="text-xs text-slate-500">GPS</dt><dd className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{a.gps ? "Terekam" : "Tidak ada"}</dd></div>
    </dl>
    {productionText(a.production) && (
      <p className="mt-2 text-sm inline-flex items-start gap-1.5 text-amber-800" data-testid={`activity-production-${a.id}`}><Coffee className="h-4 w-4 shrink-0 mt-0.5" />{productionText(a.production)}</p>
    )}
    <div className="mt-3 pt-3 border-t border-slate-100 flex flex-wrap items-center justify-between gap-2">
      <Evidence c={a.mediaCounts} />
      <span className="text-xs text-slate-500 inline-flex items-center gap-1" data-testid={`activity-reporter-${a.id}`}><Users className="h-3.5 w-3.5" />{a.farmerGroupName} × PT SJI<ChevronRight className="h-4 w-4" /></span>
    </div>
  </Link>
);
